const notesByMeasureNumber = {
    'active_measures': [32, 33, 34, 35, 36, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67],
    'records': [
        {
            "note": 'The vocal sun represnting the sample from "With You" and instrument sun representing "Viva la Vida" are on the same spot',
            "measures": [57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67]
        },
        {
            "note": "details on the suns not disappearing completely are in the section 'Extending samples that aren't heard, m32-36'",
            "measures": [32, 33, 34, 35, 36]
        }
    ]
}



export default notesByMeasureNumber